import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, updateVariableSetAggregationRule } from 'store/data/variables';

type HandlerInput = Parameters<typeof updateVariableSetAggregationRule>[0];

export function useUpdateVariableSetAggregationRule(
	ruleName: string
): Operation<(input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(
		ActionTypes.UPDATE_VARIABLE_SET_AGGREGATION_RULE,
		{
			ruleName
		}
	);

	function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(updateVariableSetAggregationRule(input));
	}

	return [{ loading, error }, handler];
}
